import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IFrequentlyAskedQuestions, AddFrequentlyAskedQuestions } from '../models/models'

export class PutFrequentlyAskedQuestionsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sss/questionAndAnswerUpdate',
      requesterInfo,
    })
  }

  public async putFrequentlyAskedQuestions(request: AddFrequentlyAskedQuestions): Promise<IFrequentlyAskedQuestions> {
    return await this.postAsync<IFrequentlyAskedQuestions>(request)
  }
}
